import React from 'react'
import LogicEditor from './components/LogicEditor'
import CardItemsRender from './components/CardItemsRender'
import TableItemsRender from './components/TableItemsRender'
import ListArray from './components/ListArray'
import RadioButton from './components/RadioButton'
import GroupSelect from './components/GroupSelect'
import relate from './relate'

import { CollapseGroup, FieldGroup, InlineGroup, SimpleGroup, ColGroup } from './components/groups'

import { Input, InputNumber } from 'antd'

export default {
  components: {
    'Form.LogicEditor': LogicEditor,
    'Form.Items.Card': CardItemsRender,
    'Form.Items.Table': TableItemsRender,
    'Form.CollapseGroup': CollapseGroup,
    'Form.FieldGroup': FieldGroup,
    'Form.InlineGroup': InlineGroup,
    'Form.SimpleGroup': SimpleGroup,
    'Form.ColGroup': ColGroup
  },
  form_fields: {
    ...relate.form_fields,
    text: {
      component: ({ input, field }) => {
        return <Input {...input} {...field.attrs} />
      },
      parse: (value) => value === '' ? null : value
    },
    radiobtn: {
      component: RadioButton
    },
    array: {
      component: ListArray
    },
    select: {
      component: GroupSelect,
      parse: (value) => value
    },
    number: {
      component: ({ input, field, field: { schema: { minimum, maximum } } }) => {
        return <InputNumber {...input} {...field.attrs} min={minimum} max={maximum} />
      },
      parse: (value) => {
        return value === '' || value == null ? null : parseFloat(value)
      },
      attrs: {
        type: 'number',
        style: {
          minWidth: 200
        }
      }
    }
  }
}
